import mergeWith from 'lodash/mergeWith';
import ManifestLoader from 'phaser-manifest-loader';
import Main from './Main';
import { customizer } from '../utils';

const req = require.context('../../assets', true, /.*\.png|json|ttf|woff|woff2|xml|mp3|jpg|jpeg$/);

const baseManifest = {
  audio: ['click', 'spin', 'select', 'stick', 'reaction', 'success', 'super_success'],
  spritesheets: ['assets', 'numbers'],
  images: ['reel', 'bg_reel_tile', 'star_particle', 'shadow', 'jackpot'],
  bitmap_fonts: ['avenir_white', 'digital_red', 'panton_white_extrabold', 'panton_green'],
};

const desktopManifest = {
  images: ['crank_piece'],
  spritesheets: ['crank'],
};

const mobileManifest = {
  spritesheets: ['red_button'],
};

export default class extends Phaser.State {
  create() {
    // console.log('boot me up', this.game.props);
    const { isDesktop } = this.game.props;
    // don't render anything until all assets are loaded
    // the canvas is transparent so you can show a loader behind it
    // in the parent app
    const fullManifest = mergeWith(
      baseManifest,
      isDesktop ? desktopManifest : mobileManifest,
      customizer,
    );
    this.setupStage();
    this.addStates();
    const loader = this.game.plugins.add(ManifestLoader, req);
    loader
      .loadManifest({
        spritesheets: ['particle'],
      })
      .then(() => {
        this.showLoader();
        loader.loadManifest(fullManifest).then(() => {
          this.startGame();
        });
      });
    this.game.manifestLoader = loader;
  }

  showLoader() {
    const p = this.game.add.sprite(this.game.world.centerX, this.game.world.centerY, 'particle');
    p.anchor.set(0.5);
    const anim = p.animations.add(
      'particle',
      Phaser.Animation.generateFrameNames('particle', 1, 33, '', 4),
      30,
      true,
    );
    anim.play();

    const txt = this.game.add.text(
      this.game.world.centerX,
      this.game.world.centerY + 80,
      'LOADING',
      {
        font:
          '18px "Avenir",-apple-system, "BlinkMacSystemFont", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fill: '#999',
      },
    );
    txt.anchor.set(0.5);
  }

  setupStage() {
    this.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;
    this.input.maxPointers = 1;
    this.scale.refresh();
  }

  addStates() {
    this.state.add('Main', Main);
  }

  startGame() {
    this.state.start('Main');
  }
}
